import * as React from "react"

import PDCLogoContainer from "./PDCLogoContainer"

export interface PageTemplateProps {
  pageTitle: string
  pageClassName?: string
  pageContentClassName?: string
}

export const PageTemplate: React.FunctionComponent<PageTemplateProps> = ({
  pageTitle,
  pageClassName,
  pageContentClassName,
  children
}) => {
  return (
    <div
      className={`ocs-page-container d-flex ${
        pageClassName ? pageClassName : ""
      }`}
    >
      <div className="ocs-sidepanel">
        <div className="ocs-sidepanel-not-collapsible-content">
          <div className="ocs-header-container d-flex flex-column align-items-center justify-content-between h-100p">
            <h2 className="ocs-header">{pageTitle}</h2>
            <PDCLogoContainer />
          </div>
        </div>
      </div>
      <section
        className={`ocs-sidepanel-right-content overflow ${pageContentClassName}`}
      >
        {children}
      </section>
    </div>
  )
}

